import { AloftPrice } from '@aloft/toolkit-shared';

export type OpinionOfValueLabel =
  | 'Opinion of Market Value'
  | 'Opinion of As-Is Value'
  | 'Opinion of After-Repair Value';

export const getOpinionOfValueOutsideAdjustedSalePriceRangeWarning = ({
  opinionOfValue,
  minCompMarketAdjustedSalePrice,
  maxCompMarketAdjustedSalePrice,
  valueLabel,
}: {
  opinionOfValue?: AloftPrice;
  minCompMarketAdjustedSalePrice?: AloftPrice;
  maxCompMarketAdjustedSalePrice?: AloftPrice;
  valueLabel: OpinionOfValueLabel;
}): string | undefined => {
  if (!opinionOfValue || !minCompMarketAdjustedSalePrice || !maxCompMarketAdjustedSalePrice) {
    return undefined;
  }

  if (
    opinionOfValue.gt(maxCompMarketAdjustedSalePrice) ||
    opinionOfValue.lt(minCompMarketAdjustedSalePrice)
  ) {
    return `${valueLabel} is not bracketed by the adjusted sales price range of Comps (${minCompMarketAdjustedSalePrice.toString(true)} - ${maxCompMarketAdjustedSalePrice.toString(true)}). Align the Opinion of Value with the analysis, or explain in Reconciliation why the current figure is appropriate despite the lack of bracketing.`;
  }

  return undefined;
};
